import styled from "styled-components";
import designSystemColors from "../../../../styles";

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-radius: 1rem;
  padding: 1rem;
  background-color: ${designSystemColors.lightBlue};
  border: 1px solid ${designSystemColors.borderBlue};
  gap: 0.5rem;
`;

export const Text = styled.span`
  font-family: "Roboto", sans-serif;
  color: ${designSystemColors.textDark};
  font-size: 16px;
`;
